import React from 'react';
import { observer } from 'mobx-react';
import { withTheme } from 'styled-components';
import Box from 'core/components/Box';
import Flex from 'core/components/Flex';
import HeaderCell from './HeaderCell';
import { getColKey } from './Cell';

const Header = (props) => {
  const {
    collection,
    headerRef,
    columns,
    resizedColumns,
    style,
    useSortTooltips,
    noHighlightSorted,
    onSort,
    tabPrefId,
    persistColumnWidths,
    updateGrid,
    columnWidthsRef,
    setIsResizing
  } = props;

  return (
    <Box ref={headerRef} className="thead">
      <Flex className="tr" style={style} borderBottom="thin">
        {columns.map((column, idx) => (
          <HeaderCell
            {...props}
            useSortTooltips={useSortTooltips}
            noHighlightSorted={noHighlightSorted}
            key={getColKey(column)}
            column={column}
            {...collection.sortState}
            isAllSelected={collection.isAllSelected}
            columns={columns}
            index={idx}
            onSort={onSort}
            resizedColumns={resizedColumns}
            tabPrefId={tabPrefId}
            persistColumnWidths={persistColumnWidths}
            updateGrid={updateGrid}
            columnWidthsRef={columnWidthsRef}
            setIsResizing={setIsResizing}
          />
        ))}
      </Flex>
    </Box>
  );
};

export default withTheme(observer(Header));
